<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>팝업 관리</strong></div>
			<h2 class="h_sub">팝업 리스트</h2>
		</div>

    <PopupManageListForm/>
  </div>
</template>

<script>
import PopupManageListForm from '@/components/admin/etc/PopupManageListForm.vue';

export default {
  components: {
    PopupManageListForm
  }    
}
</script>
<style lang="">
    
</style>